import imageIconForArboristShelterId from './../images/icons_for_shelter_type/icon_skill_arborist.png';
import imageIconForFarmerShelterId from './../images/icons_for_shelter_type/icon_skill_farm.png';
import imageIconForScientistShelterId from './../images/icons_for_shelter_type/icon_skill_science.png';
import imageIconForTechnicianShelterId from './../images/icons_for_shelter_type/icon_skill_tech.png';
import imageIconForRarity0 from './../images/icons_rarity_stars/stars_rarity_01.png';
import imageIconForRarity1 from './../images/icons_rarity_stars/stars_rarity_02.png';
import imageIconForRarity2 from './../images/icons_rarity_stars/stars_rarity_03.png';
import imageIconForRarity3 from './../images/icons_rarity_stars/stars_rarity_04.png';


export const rarityNameFor = (rarityId) => {
  switch (rarityId) {
    case 0: return "Starter";
    case "0": return "Starter";
    case 1: return "Common";
    case "1": return "Common";
    case 2: return "Rare";
    case "2": return "Rare";
    case 3: return "Legendary";
    case "3": return "Legendary";
    default:
      return "" + rarityId;
  }
};

export const petTypeNameForId = (petVisualId) => {
  if (!petVisualId) {
    return;
  }
  return shelterNameForId(petVisualId.toLowerCase());
}

export const shelterNameForId = (shelterId) => {
  // common
  if (shelterId.includes("bulldog")) return "Bulldog";
  if (shelterId.includes("bull")) return "Bull";
  if (shelterId.includes("calico")) return "Calico Cat";
  if (shelterId.includes("collie")) return "Collie";
  if (shelterId.includes("cow")) return "Cow";
  if (shelterId.includes("fluffy")) return "Fluffy Cat";
  if (shelterId.includes("goat")) return "Goat";
  if (shelterId.includes("grizzly")) return "Grizzly";
  if (shelterId.includes("horse")) return "Horse";
  if (shelterId.includes("pig")) return "Pig";
  if (shelterId.includes("pony")) return "Pony";
  if (shelterId.includes("rabbit")) return "Rabbit";
  if (shelterId.includes("raccoon")) return "Raccoon";
  if (shelterId.includes("ram")) return "Ram";
  if (shelterId.includes("scottish")) return "Scottish";
  if (shelterId.includes("sheep")) return "Sheep";
  if (shelterId.includes("shitzu")) return "Shitzu";
  // legendary
  if (shelterId.includes("peacock")) return "Peacock";
  if (shelterId.includes("phoenix")) return "Phoenix";
  if (shelterId.includes("unicorn")) return "Unicorn";
  // rare
  if (shelterId.includes("elephant")) return "Elephant";
  if (shelterId.includes("hedgehog")) return "Hedgehog";
  if (shelterId.includes("panda")) return "Panda";
  if (shelterId.includes("parrot")) return "Parrot";
  if (shelterId.includes("boar")) return "Wild Boar";

  // older ids, some are duplicates of above by switch case returns; keeping these in as a failsafe and for additional assets (i.e. dragon etc)
  if (shelterId.includes("anteater")) return "Anteater";
  if (shelterId.includes("bear")) return "Black Bear";
  if (shelterId.includes("rabbit")) return "Black Rabbit";
  if (shelterId.includes("calico")) return "Calico";
  if (shelterId.includes("camel")) return "Camel";
  if (shelterId.includes("dragon")) return "Dragon";
  if (shelterId.includes("goat")) return "Goat";
  if (shelterId.includes("horse")) return "Horse";
  if (shelterId.includes("lion")) return "Lion";
  if (shelterId.includes("mouse")) return "Mouse";
  if (shelterId.includes("mystery")) return "Mystery";
  if (shelterId.includes("parrot")) return "Parrot";
  if (shelterId.includes("phoenix")) return "Phoenix";
  if (shelterId.includes("pony")) return "Pony";
  if (shelterId.includes("ram")) return "Ram";
  if (shelterId.includes("scottish")) return "Scottish";
  if (shelterId.includes("seagull")) return "Seagull";
  if (shelterId.includes("squirrel")) return "Squirrel";
  if (shelterId.includes("triceratops")) return "Triceratops";
  if (shelterId.includes("unicorn")) return "Unicorn";

}

export const imageURLForAsset = (petVisualId) => {
  // common
  if (petVisualId.includes("bulldog")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Bulldog.png";
  if (petVisualId.includes("bull")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Bull.png";
  if (petVisualId.includes("calico")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Calico_Cat.png";
  if (petVisualId.includes("collie")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Collie.png";
  if (petVisualId.includes("cow")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Cow.png";
  if (petVisualId.includes("fluffy")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Fluffy_Cat.png";
  if (petVisualId.includes("goat")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Goat.png";
  if (petVisualId.includes("grizzly")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Grizzly.png";
  if (petVisualId.includes("horse")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Horse.png";
  if (petVisualId.includes("pig")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Pig.png";
  if (petVisualId.includes("pony")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Pony.png";
  if (petVisualId.includes("rabbit")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Rabbit.png";
  if (petVisualId.includes("raccoon")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Raccoon.png";
  if (petVisualId.includes("raccon")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Raccoon.png";
  if (petVisualId.includes("ram")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Ram.png";
  if (petVisualId.includes("scottish")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Scottish.png";
  if (petVisualId.includes("sheep")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Sheep.png";
  if (petVisualId.includes("shitzu")) return "/dev-only-temporary/Assets/NFT-Images/COMMON/PROFILE_COM_Shitzu.png";
  // legendary
  if (petVisualId.includes("peacock")) return "/dev-only-temporary/Assets/NFT-Images/LEGENDARY/PROFILE_LEG_Peacock.png";
  if (petVisualId.includes("phoenix")) return "/dev-only-temporary/Assets/NFT-Images/LEGENDARY/PROFILE_LEG_Phoenix.png";
  if (petVisualId.includes("unicorn")) return "/dev-only-temporary/Assets/NFT-Images/LEGENDARY/PROFILE_LEG_Unicorn.png";
  // rare
  if (petVisualId.includes("elephant")) return "/dev-only-temporary/Assets/NFT-Images/RARE/PROFILE_RARE_Elephant.png";
  if (petVisualId.includes("hedgehog")) return "/dev-only-temporary/Assets/NFT-Images/RARE/PROFILE_RARE_Hedgehog.png";
  if (petVisualId.includes("panda")) return "/dev-only-temporary/Assets/NFT-Images/RARE/PROFILE_RARE_Panda.png";
  if (petVisualId.includes("parrot")) return "/dev-only-temporary/Assets/NFT-Images/RARE/PROFILE_RARE_Parrot.png";
  if (petVisualId.includes("boar")) return "/dev-only-temporary/Assets/NFT-Images/RARE/PROFILE_RARE_Wild_Boar.png";

  // older ids, some are duplicates of above by switch case returns; keeping these in as a failsafe and for additional assets (i.e. dragon etc)
  if (petVisualId.includes("anteater")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_anteater.png";
  if (petVisualId.includes("bear")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_black_bear.png";
  if (petVisualId.includes("rabbit")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_black_rabbit.png";
  if (petVisualId.includes("calico")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_calico.png";
  if (petVisualId.includes("camel")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_camel.png";
  if (petVisualId.includes("dragon")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_dragon.png";
  if (petVisualId.includes("goat")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_goat.png";
  if (petVisualId.includes("horse")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_horse.png";
  if (petVisualId.includes("lion")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_lion.png";
  if (petVisualId.includes("mouse")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_mouse.png";
  if (petVisualId.includes("mystery")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_mystery.png";
  if (petVisualId.includes("parrot")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_parrot.png";
  if (petVisualId.includes("phoenix")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_phoenix.png";
  if (petVisualId.includes("pony")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_pony.png";
  if (petVisualId.includes("ram")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_ram.png";
  if (petVisualId.includes("scottish")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_scottish.png";
  if (petVisualId.includes("seagull")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_seagull.png";
  if (petVisualId.includes("squirrel")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_squirrel.png";
  if (petVisualId.includes("triceratops")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_triceratops.png";
  if (petVisualId.includes("unicorn")) return "/dev-only-temporary/Assets/pack_mock-up_01_576x576_set_01_unicorn.png";

  // placeholder
  return "/dev-only-temporary/pack_mock-up_01_576x576_set_01_placeholder.png";
};


export const getMagmicCoinPriceForString = (priceString) => {
  if (!priceString) {
    return;
  }
  if (isNaN(priceString)) {
    return;
  }
  const priceInt = parseInt(priceString, 10);
  return Math.ceil(priceInt / 1000000000);
}

export const getMagmicCoinPrice = (marketplaceTransactionItem) => {

  const fullPrice = marketplaceTransactionItem.fullPrice ? marketplaceTransactionItem.fullPrice : undefined;
  if (!fullPrice) {
    console.error("Marketplace getMagmicCoinPrice fullPrice not found");
    return;
  }

  const priceInt = parseInt(fullPrice, 10);
  return Math.ceil(priceInt / 1000000000);
}

export const getMagmicCoinBalanceString = (magmicCoinBillionsInt) => {
  if (magmicCoinBillionsInt === undefined) {
    return magmicCoinBillionsInt;
  }

  let magmicCoinBalanceFloat = 0;
  if (magmicCoinBillionsInt > 0 ) {
    magmicCoinBalanceFloat = magmicCoinBillionsInt / 1000000000;
  } else {
    magmicCoinBalanceFloat = 0;
  }

  // cast to an Int and then return string (does not round, drops the decimals)
  return parseInt(magmicCoinBalanceFloat).toString(); // https://magmic.atlassian.net/browse/MC-113

  /* If decimal places required in the future
  // regex source: https://stackoverflow.com/a/4187164/999934
  const with2Decimals = magmicCoinBalanceFloat.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
  return with2Decimals;
  */
}

export const iconURLForRarityId = (rarityId) => {
  switch (rarityId) {
    case "0":
    case 0:
      return imageIconForRarity0
    case "1":
    case 1:
      return imageIconForRarity1
    case "2":
    case 2:
      return imageIconForRarity2
    case "3":
    case 3:
      return imageIconForRarity3
    default:
      break;
  }
}

export const iconUrlForShelterId = (shelterId) => {
  const shelterIdLowercased = shelterId.toLowerCase().trim();
  if (shelterIdLowercased.includes("arborist")) {
    return imageIconForArboristShelterId;
  }
  if (shelterIdLowercased.includes("farmer")) {
    return imageIconForFarmerShelterId;
  }
  if (shelterIdLowercased.includes("scientist")) {
    return imageIconForScientistShelterId;
  }
  if (shelterIdLowercased.includes("technician")) {
    return imageIconForTechnicianShelterId;
  }
  return;
}


export const titleForShelterId = (shelterId) => {
  const shelterIdLowercased = shelterId.toLowerCase().trim();
  if (shelterIdLowercased.includes("arborist")) {
    return "Arborist";
  }
  if (shelterIdLowercased.includes("farmer")) {
    return "Farmer";
  }
  if (shelterIdLowercased.includes("scientist")) {
    return "Scientist";
  }
  if (shelterIdLowercased.includes("technician")) {
    return "Technician";
  }
  if (shelterIdLowercased.includes("rare")) {
    return "Rare"
  }
  return shelterId;
}

export const iconURLForSpecialty = (specialty) => {

  if (!specialty) {
    return null;
  }

  const specialtyLowercase = specialty.toLowerCase().trim();
  const iconsPath = "images/icons_specialties/00_R/";

  if (specialtyLowercase.includes("sugar")) {
    return iconsPath + "R2_sugar.png";
  }

  if (specialtyLowercase.includes("spice")) {
    return iconsPath + "R8_Spice.png";
  }

  if (specialtyLowercase.includes("flour")) {
    return iconsPath + "R1_flour.png";
  }

  if (specialtyLowercase.includes("chocolate")) {
    return iconsPath + "R6_Chocolate.png";
  }

  if (specialtyLowercase.includes("citrus")) {
    return iconsPath + "R7_citrus.png";
  }

  if (specialtyLowercase.includes("strawberry")) {
    return iconsPath + "R4_Strawberry.png";
  }

  if (specialtyLowercase.includes("nuts")) {
    return iconsPath + "R5_Nuts.png";
  }

  if (specialtyLowercase.includes("mango")) {
    return iconsPath + "R3_mango.png";
  }
}

export const nameForSpecialty = (specialty) => {

  if (!specialty) {
    return "";
  }

  const specialtyLowercase = specialty.toLowerCase().trim();

  if (specialtyLowercase.includes("sugar")) {
    return "Sugar";
  }

  if (specialtyLowercase.includes("spice")) {
    return "Spice";
  }

  if (specialtyLowercase.includes("flour")) {
    return "Flour";
  }

  if (specialtyLowercase.includes("chocolate")) {
    return "Chocolate";
  }

  if (specialtyLowercase.includes("citrus")) {
    return "Citrus";
  }

  if (specialtyLowercase.includes("strawberry")) {
    return "Strawberry";
  }

  if (specialtyLowercase.includes("nuts")) {
    return "Nuts";
  }

  if (specialtyLowercase.includes("mango")) {
    return "Mango";
  }

  return "";
}

export const iconURLForBonusType = (bonusType) => {

  if (!bonusType) {
    return null;
  }

  const iconsPath = "images/icons_bonus_types/";

  switch (bonusType) {
    case "MiniGameSpeedBonus":
      return iconsPath + "ICON_Bonus_Speed.png";
    case "AutomateDiscountBonus":
      return iconsPath + "ICON_Bonus_Automate.png";
    case "OfflineTimeBonus":
      return iconsPath + "ICON_Bonus_Offline.png";
    default:
      return;
  }
}

export const nameForBonusTypeAndValue = (bonusType, bonusValue) => {

  if (!bonusType) {
    return "";
  }

  switch (bonusType) {
    case "MiniGameSpeedBonus":
      return "Speed Bursts (" + bonusValue * 100 + "%)";
    case "AutomateDiscountBonus":
      return "Discount";
    case "OfflineTimeBonus":
      return "+" + bonusValue + "Min";
    default:
      return "";
  }
}

export const sortPets = (pets, ascending = false, rarityWeight = 1, levelWeight = 0) => { // default is sort descending by rarity then level
  if (!pets || pets.length === 0) {
    return pets;
  }
  pets.sort( (petA, petB) => {

    if (rarityWeight >= levelWeight) { // rarity will take precendence if both weights are equal

      if (petA.rarity === petB.rarity) {
        if (petA.level >= petB.level) {
          return ascending ? 1 : -1; // petA has same rarity, but higher level means higher precedence (if default ascending)
        } else {
          return ascending ? -1 : 1;
        }
      } else if (petA.rarity > petB.rarity) {
        return ascending ? 1 : -1;
      } else {
        return ascending ? -1 : 1;
      }

    } else { // level takes precendence over rarity

      if (petA.level === petB.level) {
        if (petA.rarity >= petB.rarity) {
          return ascending ? 1 : -1; // petA has same level, but higher rarity means higher precedence (if default ascending)
        } else {
          return ascending ? -1 : 1;
        }
      } else if (petA.level > petB.level) {
        return ascending ? 1 : -1;
      } else {
        return ascending ? -1 : 1;
      }

    }
  });
}

export const sortTranscations = (transactions, ascending = false, priceWeight = 2, rarityWeight = 1, levelWeight = 0) => { // default is sort descending by rarity then level
  if (!transactions || transactions.length === 0) {
    return transactions;
  }

  let priceWeightIndex = 0; // highest rank/precedence by default
  let rarityWeightIndex = 1; // second highest rank
  let levelWeightIndex = 2; // third highest rank
  if (priceWeight < rarityWeight || priceWeight < levelWeight) {

    if (rarityWeight >= levelWeight) {
      rarityWeightIndex = 0;

      if (priceWeight >= levelWeightIndex) {
        priceWeightIndex = 1;
        levelWeightIndex = 2;  
      } else {
        levelWeightIndex = 1;  
        priceWeightIndex = 2;
      }


    } else {
      levelWeightIndex = 0;

      if (priceWeight >= rarityWeightIndex) {
        priceWeightIndex = 1;
        rarityWeightIndex = 2;
      } else {
        rarityWeightIndex = 1;
        priceWeightIndex = 2;
      }
    }
  }


  transactions.sort( (transactionA, transactionB) => {

    let transactionASortScores = [0,0,0]; // for creating a concatenated string to parse as Integer (higher weight items get higher)
    let transactionBSortScores = [0,0,0];

    /* napkin notes: (not using array in these notes, indexes are a factor in real code)
      transactionA = {price: 10, rarity: 2, level: 1}
      transactionB = {price: 9, rarity: 2, level: 3}
      transactionC = {price: 9, rarity: 3, level: 5}

      transactions = [transactionA, transactionB, transactionC]


      transactionA = 1.0.0 = "100" = 100
      transactionB = 0.0.0 = "000" =   0
      transactionC = 0.1.1 = "011" =  11

      A, C, B
    */

    const transactionAFullPrice = parseInt(transactionA.fullPrice ? transactionA.fullPrice : 0, 10);
    const transactionBFullPrice = parseInt(transactionB.fullPrice ? transactionB.fullPrice : 0, 10);

    if (transactionAFullPrice === transactionBFullPrice) { // no defaults for '>=' (full granularity on all comparisons since they are ranked already)
      transactionASortScores[priceWeightIndex] = 1;
      transactionBSortScores[priceWeightIndex] = 1;
    } else if (transactionAFullPrice > transactionBFullPrice) {
      transactionASortScores[priceWeightIndex] = 1;
      transactionBSortScores[priceWeightIndex] = 0;
    } else {
      transactionASortScores[priceWeightIndex] = 0;
      transactionBSortScores[priceWeightIndex] = 1;
    }

    let petA = transactionA.pet ? transactionA.pet : {rarity: 0, level: 0};
    let petB = transactionB.pet ? transactionB.pet : {rarity: 0, level: 0};

    if (petA.rarity === petB.rarity) {
      transactionASortScores[rarityWeightIndex] = 1;
      transactionBSortScores[rarityWeightIndex] = 1;
    } else if (petA.rarity > petB.rarity) {
      transactionASortScores[rarityWeightIndex] = 1;
      transactionBSortScores[rarityWeightIndex] = 0;
    } else {
      transactionASortScores[rarityWeightIndex] = 0;
      transactionBSortScores[rarityWeightIndex] = 1;
    }

    if (petA.level === petB.level) {
      transactionASortScores[levelWeightIndex] = 1;
      transactionBSortScores[levelWeightIndex] = 1;
    } else if (petA.level > petB.level) {
      transactionASortScores[levelWeightIndex] = 1;
      transactionBSortScores[levelWeightIndex] = 0;
    } else {
      transactionASortScores[levelWeightIndex] = 0;
      transactionBSortScores[levelWeightIndex] = 1;
    }

    const transactionASortScore = parseInt(transactionASortScores.join(""), 10);
    const transactionBSortScore = parseInt(transactionBSortScores.join(""), 10);

    if (ascending) {
      return transactionASortScore >= transactionBSortScore ? 1 : -1;
    } else {
      return transactionASortScore >= transactionBSortScore ? -1 : 1;
    }
  });
}